import { c as _c } from "react/compiler-runtime";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import CommonAnimationHeight from "@/components/utils/animation/CommonAnimationHeight";
export default function CreateWaveNameInput(t0) {
  const $ = _c(20);
  const {
    name,
    errors,
    onChange
  } = t0;
  let t1;
  if ($[0] !== errors) {
    t1 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.NAME_REQUIRED);
    $[0] = errors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isNameError = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = event => {
      onChange({
        key: "name",
        value: event.target.value
      });
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onNameChange = t2;
  const t3 = `${isNameError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error" : "tw-ring-iron-650 tw-border-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400"} tw-form-input tw-block tw-px-4 tw-pt-4 tw-pb-3 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none ${name ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"}  tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t4;
  if ($[4] !== name || $[5] !== onNameChange || $[6] !== t3) {
    t4 = <input type="text" onChange={onNameChange} value={name} id="create-wave-name" autoComplete="off" className={t3} placeholder=" " />;
    $[4] = name;
    $[5] = onNameChange;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${isNameError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2 peer-placeholder-shown:tw-scale-100 
      peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t6;
  if ($[8] !== t5) {
    t6 = <label htmlFor="create-wave-name" className={t5}>Name</label>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="tw-group tw-w-full tw-relative"><div className="tw-relative">{t4}{t6}</div></div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isNameError) {
    t8 = isNameError && <div className="tw-pt-1.5 tw-relative tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-relative tw-z-10 tw-text-error tw-text-xs tw-font-medium">Name is required</div></div>;
    $[13] = isNameError;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <CommonAnimationHeight>{t8}</CommonAnimationHeight>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-gap-y-6"><div>{t7}{t9}</div></div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}